import { useRef } from 'react';
import { UploadIcon } from 'lucide-react';

import { Button } from '@/components/ui/button';

type LogoUploadFieldProps = {
  value: File | string | null;
  onChange: (file: File | null) => void;
};

const LogoUploadField = ({ value, onChange }: LogoUploadFieldProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.files?.[0] ?? null);
    event.target.value = '';
  };

  const handleUploadClick = () => inputRef.current?.click();
  const handleRemove = () => onChange(null);

  return (
    <div className="flex items-center gap-2">
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        className="hidden"
        aria-label="Upload logo"
        onChange={handleFileChange}
      />
      <Button type="button" variant="outline" size="sm" onClick={handleUploadClick}>
        <UploadIcon className="size-3.5!" />
        {value ? 'Replace logo' : 'Upload a logo'}
      </Button>
      {value && (
        <Button type="button" variant="ghost" size="sm" onClick={handleRemove}>
          Remove logo
        </Button>
      )}
    </div>
  );
};

export default LogoUploadField;
